// English strings: the source for every language. ja.ts and ko.ts must have the same keys
// (typed as Dict, so a missing key is a compile error; at run time it falls back to English).
// {name} placeholders are filled in by t(); keep them in translations.
const en = {
  // Shared
  "common.you": "You",
  "common.computer": "Computer",
  "common.computerN": "Computer {n}",
  "common.andList": "{list} and {last}",
  "common.listSep": ", ",
  "common.theRoomOwner": "the room owner",
  "common.someone": "Someone",
  "common.language": "Language",

  // Cards
  "card.joker": "Joker",
  "card.A": "Ace",
  "card.J": "Jack",
  "card.Q": "Queen",
  "card.K": "King",
  "card.blackKing": "black King",
  "card.redKing": "red King",
  "suit.H": "Hearts",
  "suit.D": "Diamonds",
  "suit.S": "Spades",
  "suit.C": "Clubs",
  "card.of": "{rank} of {suit}",

  // House-rule presets (names other than Rafiki may be given in katakana/hangul too)
  "preset.rafiki": "Rafiki",
  "preset.gringo": "Gringo",
  "preset.cambio": "Cambio",
  "preset.cabo": "Cabo",
  "preset.kaboo": "Kaboo",

  // What to do now (the turn's instruction)
  "turn.replace": "Replace a card in your hand with this card.",
  "turn.lookAtOwn": "Look at a card in your hand.",
  "turn.lookAtOpponents": "Look at a card in an opponent's hand.",
  "turn.swapWithOpponent": "Swap one of your own cards with an opponent's card. Without looking at the cards!",
  "turn.swapBetweenOpponents":
    "Swap the position of two cards in an opponent’s hand (either the same opponent, or between opponents). Without looking at the cards!",
  "turn.blindSwap":
    "Swap one of your own cards with an opponent's card or swap the position of two cards between opponents. Without looking at the cards!",

  // Table messages (the line along the bottom)
  "msg.youSwappedWith": "You swapped one of your cards with one of {name}'s cards.",
  "msg.swappedWithYou": "{name} swapped one of their cards with yours.",
  "msg.swappedWith": "{name} swapped one of their cards with one of {other}'s cards.",
  "msg.youSlamOwn": "You chose to SLAM! Choose your SLAM CARD from your own hand now!",
  "msg.youSlam": "You chose to SLAM! Choose your SLAM CARD now!",
  "msg.choseToSlam": "{name} chose to SLAM!",
  "msg.yourSlamCorrectPick": "Your Slam was correct! Pick a card to discard to transfer to your opponent.",
  "msg.slamCorrect": "{name}'s Slam was correct!",
  "msg.youSlamTooLong": "You took too long to Slam.",
  "msg.slamTooLong": "{name} took too long to Slam.",
  "msg.youSlammedWrong": "You have slammed incorrectly!",
  "msg.slamWrong": "{name}'s Slam was incorrect!",
  "msg.youSlammedRight": "You slammed correctly.",
  "msg.slammedRight": "{name} slammed correctly.",
  "msg.youTimedOutPenalty": "You timed out and received a penalty card.",
  "msg.timedOutPenalty": "{name} timed out and received a penalty card.",
  "msg.youTimedOut": "You timed out.",
  "msg.timedOut": "{name} timed out.",
  "msg.left": "{name} left the game.",
  "msg.aPlayerLeft": "A player left the game.",
  "msg.youRemoved": "You were removed due to inactivity.",
  "msg.removedOne": "{names} was removed due to inactivity.",
  "msg.removedMany": "{names} were removed due to inactivity.",
  "msg.youNoMove": "You had no playable move.",
  "msg.noMove": "{name} had no playable move.",
  "msg.youDiscardedDrawn": "You discarded the card you drew.",
  "msg.discardedDrawn": "{name} discarded the card they drew.",
  "msg.youReplaced": "You replaced one of your cards.",
  "msg.replaced": "{name} replaced one of their cards.",
  "msg.youPeeked": "You looked at one of your own cards.",
  "msg.peeked": "{name} looked at one of their own cards.",
  "msg.spiedOnYou": "{name} looked at one of your cards.",
  "msg.youSpied": "You looked at one of {name}'s cards.",
  "msg.spied": "{name} looked at one of {other}'s cards.",
  "msg.waitingReady": "Waiting for everyone to be ready.",
  "msg.yourTurnDraw": "It is your turn, pick up a card from the deck.",
  "msg.theirTurn": "It's {name}'s turn.",
  "msg.drewPower": "You have drawn the {card}. It goes on the discard pile and you use its power.",
  "msg.drew": "You have drawn the {card}.",
  "msg.youHave": "You have the {card}. Tap it again to put it back.",
  "msg.theyHave": "{name} has the {card}. Tap it again to put it back.",
  "msg.clockTicking": "The clock is ticking! Time to make your move.",
  "msg.startNew": "Start a new game.",
  "msg.waitingOwner": "Waiting for {name} to start a new game.",
  "msg.youWonGameShort": "Congratulations! You won the game!",
  "msg.youWonGame": "Congratulations! You have won the game!",
  "msg.wonGame": "{name} won the game!",
  "msg.youWonRound": "Congratulations! You have won this round!",
  "msg.wonRound": "{name} won the round!",
  "msg.youTied": "Congratulations! You are tied with {names}.",
  "msg.tied": "{names} have tied!",
  "msg.ownerLeft": "Game has ended. The room owner left the game.",
  "msg.revealed": "Cards are revealed.",
  "msg.waitingOthers": "Waiting for other players.",
  "msg.rememberTwo": "Remember your two face-up cards, then press Ready.",
  "msg.youCalled": "You called {call}!",
  "msg.yourLastTurn": "It is your last turn. {call} has been called by {name}.",
  "msg.theirLastTurn": "It is {player}'s last turn. {call} has been called by {name}.",
  "msg.twoSentences": "{a} {b}",

  // Slam result
  "slam.failTitle": "SLAM FAIL!",
  "slam.correctTitle": "CORRECT SLAM!",
  "slam.youWrong": "Your slam card does not match the rank of the discarded card. You will suffer a penalty!",
  "slam.theyWrong": "{name}'s slam card does not match the rank of the discarded card. They will suffer a penalty!",
  "slam.youRight": "Your slam card matches the rank of the discarded card.",
  "slam.theyRight": "{name}'s slam card matches the rank of the discarded card.",
  "slam.youRightPick": "Your slam card matches the rank of the discarded card. Pick a card to discard to transfer to your opponent.",

  // Round and game over
  "over.endOfN": "End of {count} round game!",
  "over.youWon": "You won!",
  "over.gameOver": "Game over",
  "over.congrats": "Congratulations!",
  "over.roundOver": "Round Over!",
  "over.youWonRound": "You have won this round with a score of {score} points!",
  "over.lowestWinsYou": "Lowest score wins: you had {score}.",
  "over.wonRound": "{name} won the round with a score of {score}!",
  "over.winsWith": "{name} wins with {score}. Lowest score wins!",
  "over.hasWonGame": "{name} has won the game!",
  "over.youTied": "You are tied with {names} with a score of {score} points!",
  "over.tied": "{names} have tied with a score of {score} points!",
  "over.youBonus": "You take {n} points off for calling {call} and winning.",
  "over.bonus": "{name} takes {n} points off for calling {call} and winning.",
  "over.youPenalty": "You called {call} but weren't lowest: +{n}.",
  "over.penalty": "{name} called {call} but wasn't lowest: +{n}.",

  // On-table guide (what to tap next)
  "guide.worth": "worth {points}",
  "guide.lookAndSwap": "look and swap",
  "guide.bestPower": "best power card",
  "guide.peekCard": "peek card",
  "guide.spyCard": "spy card",
  "guide.swapCard": "swap card",
  "guide.usePower": "use its power",
  "guide.passHigh": "pass on a high card",
  "guide.keepIt": "{pts}: keep it!",
  "guide.goodLow": "{pts}: good low card",
  "guide.middling": "{pts}: middling",
  "guide.highThrow": "{pts}: high, maybe throw it",
  "guide.high": "{pts}: high",
  "guide.powerVerdict": "{power}, {verdict}",
  "guide.slam": "Slam!",
  "guide.slamOwn": "Tap the card in your hand that matches the top of the discard pile.",
  "guide.slamAny": "Tap the card that matches the top of the discard pile.",
  "guide.niceSlam": "Nice slam!",
  "guide.niceSlamDetail": "Now tap one of your cards to give them.",
  "guide.wrongCard": "Wrong card",
  "guide.wrongCardDetail": "Tap the slam message to take your penalty card.",
  "guide.isSlamming": "{name} is slamming!",
  "guide.isPlaying": "{name} is playing…",
  "guide.theirTurn": "{name}'s turn",
  "guide.yourTurn": "Your turn",
  "guide.drawOrCall": "Tap the deck to draw, or press Call {call}! if you think you're lowest.",
  "guide.deckDraw": "Draw",
  "guide.tapDeck": "Tap the deck to draw a card.",
  "guide.swapInOrThrow": "Tap one of your cards to swap it in, or the discard pile to throw it away.",
  "guide.throwAway": "Throw away",
  "guide.swapIn": "Tap one of your cards to swap it in. Swap out one you know is higher.",
  "guide.whatLookSwap": "look at someone's card, then swap",
  "guide.whatPeek": "peek at one of your cards",
  "guide.whatSpy": "look at someone else's card",
  "guide.whatBlind": "swap cards blind",
  "guide.next": "Next: {what}.",
  "guide.peek": "Peek",
  "guide.peekDetail": "Tap one of your cards to look at it.",
  "guide.rememberIt": "Remember it!",
  "guide.turnBack": "Tap the card again to turn it back over (it turns back by itself after 5 seconds).",
  "guide.spy": "Spy",
  "guide.spyDetail": "Tap someone else's card to look at it.",
  "guide.swap": "Swap",
  "guide.nowTheirs": "Now tap someone else's card to swap with.",
  "guide.nowYours": "Now tap one of your cards to swap with.",
  "guide.nowSwap": "Now swap",
  "guide.blindSwap": "Blind swap",
  "guide.swapDetail": "Tap one of your cards and one of someone else's to swap them.",
  "guide.swapTwo": "Tap two other players' cards to swap them.",

  // Coaching tips
  "hint.aRank": "A {rank}",
  "hint.anRank": "An {rank}",
  "hint.call": "Think your total is the lowest? Call {call}! Everyone else gets one last turn.",
  "hint.draw": "Lowest total wins. Draw from the deck (not the discard pile) and keep your low cards.",
  "hint.blackKing": "A black King lets you look and swap. Tap the discard pile, look at an opponent's card, then swap one of yours with any opponent's card.",
  "hint.rankPeek": "{card} lets you peek. Tap the discard pile, then tap one of your cards.",
  "hint.rankSpy": "{card} lets you spy. Tap the discard pile, then tap an opponent's card.",
  "hint.rankSwap": "{card} swaps blind. Tap the discard pile, then swap a card without looking.",
  "hint.usePower": "Tap the discard pile to use this card's power.",
  "hint.nowSwap": "Now swap: tap one of your cards, then an opponent's card.",
  "hint.replaceOrThrow": "Tap one of your cards to swap this one in, or tap the discard pile to throw it away. Red Kings are {redKing}, Jokers {joker}, Aces 1.",
  "hint.peek78": "7s and 8s let you peek at your own cards. Check the ones you haven't seen yet.",
  "hint.spy910": "9s and 10s let you spy. Spot someone's low card, then steal it later with a swap.",
  "hint.swapJQK": "Jacks, Queens and black Kings swap blind. Give away a card you know is high.",
  "hint.powerCards": "Power cards can't go in your hand, but their powers help you find the low cards.",
  "hint.rememberOwn": "Remember it: the whole game is knowing where the low cards are.",
  "hint.rememberTheirs": "Remember it. If it's low, a swap card can steal it later.",
  "hint.lowCards": "Low cards (Ace to 6, Jokers, red Kings) go in your hand. Swap out a high or unseen card.",
  "hint.slamOwn": "One of your cards matches the pile's top card? Press Slam, then tap it.",
  "hint.slamAny": "Know a card that matches the pile's top card? Press Slam, then tap it.",
  "hint.default": "Lowest total wins. Remember where your low cards are.",
  "hint.tip": "Tip:",
  "hint.hide": "Hide tips",

  // The table
  "stamp.oops": "Oops!",
  "stamp.miss": "Miss!",
  "stamp.slam": "Slam!",
  "table.noDiscardTake": "You can't take from the discard pile. Tap the deck to draw a card.",
  "table.discardPile": "Discard pile",
  "table.deck": "Deck",
  "table.yourTurnBanner": "Your turn!",
  "table.dealing": "Dealing the cards…",
  "table.nameLeft": "{name} left the game",
  "table.notReady": "(not ready)",
  "table.thinking": "thinking",
  "table.call": "Call {call}!",
  "table.slam": "Slam",
  "lobby.startGame": "Start Game",

  // Room menu (top left of the table)
  "menu.soundOnAria": "Turn sound on",
  "menu.soundOffAria": "Turn sound off",
  "menu.soundOn": "Sound on",
  "menu.soundOff": "Sound off",
  "menu.roundOfDeath": "Round of Death",
  "menu.roundN": "Round {round}/{rounds}",
  "menu.yourRoom": "Your room",
  "menu.theirRoom": "{name}'s room",
  "menu.exitHome": "Exit to home",
  "menu.resume": "Resume game",
  "menu.pause": "Pause game",
  "menu.backToLobby": "Back to lobby",
  "menu.removePlayers": "Remove players",
  "menu.passRoom": "Pass room",
  "menu.hideHints": "Hide hints",
  "menu.showHints": "Show hints",
  "menu.signOut": "Sign out",
  "menu.policies": "Policies",
  "menu.rules": "Rules",

  // Call screen
  "call.youCalled": "You have called {call}",
  "call.yourHandProtected": "Your hand is protected.",
  "call.opponentsOneMore": "Your opponents have one more turn before all cards are revealed…",
  "call.opponentOneMore": "Your opponent has one more turn before all cards are revealed…",
  "call.theyCalled": "{name} has called {call}",
  "call.theirHandProtectedMany": "{name}’s hand is protected! One more turn for you and {name}’s other opponents.",
  "call.theirHandProtected": "{name}’s hand is protected! One more turn for you.",
  "call.thenRevealed": "All cards will then be revealed…",

  // Scoreboard
  "over.thisRound": "This round",
  "over.total": "Total",
  "over.startNewRound": "Start new round",
  "over.showResult": "Show result",
  "over.home": "Home",
  "over.deckLink": "Like Rafiki? Get the real deck →",
  "over.nextRoundIn": "Next round ({s})",
  "over.roundOfN": "Round {round} of {rounds} done.",
  "over.matchBehind": "You're {n} behind {name},",
  "over.matchLead": "You're leading by {n},",
  "over.matchLevel": "You're level with {name},",
  "over.roundsLeft1": "one round to go.",
  "over.roundsLeftN": "{n} rounds to go.",
  "over.playAgain": "Play again",
  "over.playMatchN": "Play a {n}-round match",
  "over.startRoundOfDeath": "Start round of death",
  "over.startNewGame": "Start new game",
  "over.catchUpN": "Round {round} of {rounds} done. {name} is ahead for now, with {left} rounds to go: plenty of time to catch up.",
  "over.catchUp1": "Round {round} of {rounds} done. One round left: a low hand can still win it.",
  "over.wonMatchBy": "You won the match by {n}!",
  "over.lostMatchBy": "{name} won the match by {n}.",
  "over.legend": "★ won the round · 🏆 won the match · lowest total wins",
  "over.rematchIn": "Rematch in {s}…",
  "over.nextOpponentIn": "Next opponent in {s}…",
  "over.stayHere": "Stay here",
  "over.rematch": "Rematch",
  "over.nextOpponent": "Next opponent",
  "ladder.progress": "Master {n} of {total}: {name}, {place}",
  "ladder.beat": "You beat {name}! Next up: {next}.",
  "ladder.champion": "You've beaten all eight Masters! Nonna wants a rematch.",
  "ladder.place.beach": "on a beach holiday",
  "ladder.place.train": "on the night train",
  "ladder.place.surf": "back from the surf",
  "ladder.place.cafe": "at a pavement café",
  "ladder.place.ski": "in a ski chalet",
  "ladder.place.cruise": "on a cruise",
  "ladder.place.market": "at the Christmas market",
  "ladder.place.villa": "at her villa",
  "table.slamLater": "Slam unlocks next round",
  "help.thisTurn": "This turn",
  "help.peekNow": "Remember your two cards",
  "help.peekDetail": "The two face-up cards nearest you are yours. Remember them, then tap Ready.",
  "help.waitDetail": "Watch what they do: you'll be told when it's your turn.",
  "help.roundEnd": "The round is over: here come the scores.",
  "help.aim": "Lowest total wins. Swap your high cards for low ones and call {call} when you think you're lowest.",
  "help.powers": "Some cards have a power when you draw them: the game tells you what each one does.",
  "help.gameWaits": "The game waits while this is open.",
  "help.back": "Back to the game",
  "help.fullRules": "Full rules",
  "share.challengeCopied": "Challenge link copied! Paste it to a friend.",
  "share.challengeFriend": "Challenge a friend",

  // Peek at the start of a round
  "peek.aria": "Remember your two cards",
  "peek.title": "Remember these two",
  "peek.detail": "Tap Ready as soon as you've got them.",
  "peek.matchIntro": "{n}-round match: lowest total score wins.",
  "peek.readyN": "Ready ({n})",
  "peek.ready": "Ready",
  "peek.extraAd": "Watch an ad for an extra peek",

  // Other in-game modals
  "pause.title": "Game paused",
  "pause.you": "You have paused the game.",
  "pause.they": "{name} has paused the game.",
  "timeout.title": "Timed Out",
  "full.title": "ROOM FULL",
  "full.has6": "This room already has 6 players.",
  "full.waitOrCreate": "You can wait or create a new room.",
  "full.createRoom": "Create Room",
  "denied.title": "Denied",
  "denied.text": "You were denied entry into the room.",
  "denied.tryAgain": "Try Again",
  "pass.title": "Pass ownership of the room to another player",
  "pass.text": "Choose a player to whom who you would like to transfer room ownership. They will have the same privileges you have now, and you will demote to an ordinary player of this game. Room ownership can be transferred any time in the game by the owner.",
  "pass.cancel": "Cancel and return to game",
  "join.title": "Join Game",
  "join.enterCode": "Enter the room code.",
  "join.portalHelp": "It's the four characters in the invite the room owner sent you.",
  "join.webHelp": "The room code is the last four numbers / digits in the room owners URL.",
  "join.noRoom": "Room doesn't exist",
  "join.join": "Join",
  "guest.nameTooShort": "Please enter a name of at least 2 letters.",
  "guest.failed": "Couldn't join just now. Please try again.",
  "guest.title": "Join the game",
  "guest.text": "Type your name and you're in. No account needed.",
  "guest.yourName": "Your name",
  "guest.joining": "Joining...",
  "guest.join": "Join as guest",
  "guest.haveAccount": "I have an account: log in",
  "remove.title": "Remove Players",
  "remove.list": "Player list",
  "remove.remove": "Remove",
  "remove.removed": "Removed!",
  "lobby.houseRules": "House rules",
  "offline.title": "Internet disconnected",
  "offline.text": "You seem to be disconnected from the internet. Check your network connection.",

  // Lobby
  "lobby.title": "Game Lobby",
  "lobby.statusIn": "in",
  "lobby.statusNotIn": "not let in",
  "lobby.statusWaiting": "waiting to be let in",
  "lobby.waitingStart": "Waiting for {name} to start the game",
  "lobby.waitingLetIn": "Waiting for {name} to let you in",
  "lobby.enterName": "Enter your name",
  "lobby.players": "Players",
  "lobby.roomOwner": "Room owner",
  "lobby.startsTheGame": "starts the game",
  "lobby.nameYou": "{name} (you)",
  "lobby.guest": "Guest",
  "lobby.computer": "computer",
  "lobby.onlyOwnerStarts": "Only {name} can start the game",
  "lobby.ownerDecides": "{name} decides who plays",
  "lobby.hintAddComputer": "Add a computer player to begin",
  "lobby.hintDiscord": "Add a computer player, or wait for friends in the call to open Rafiki",
  "lobby.hintInvite": "Add a computer player, or tap Invite friends and wait for one to join",
  "lobby.hintApprove": "Approve everyone to begin game",
  "lobby.rounds": "Number of rounds",
  "lobby.playersInCall": "Players in this call",
  "lobby.playersJoined": "Players who joined",
  "lobby.approvePlayers": "Approve human players",
  "lobby.noOneLink": "No one yet. Tap Invite friends to send the link.",
  "lobby.noOneCode": "No one yet. Tap Invite friends to send the room code.",
  "lobby.deny": "Deny",
  "lobby.approve": "Approve",
  "lobby.approved": "Approved!",
  "lobby.denied": "Denied!",
  "lobby.addComputers": "Add computer players",
  "lobby.add": "Add",
  "lobby.addAnother": "Add another",
  "lobby.startGameLower": "Start game",
  "lobby.clickToRename": "Click to rename",
  "lobby.difficulty": "Difficulty",
  "lobby.bot.Rookie": "Rookie",
  "lobby.bot.Voyager": "Voyager",
  "lobby.bot.Master": "Master",
  "lobby.note.rafiki": "Rafiki: 7-8 peek, 9-10 spy, Jack/Queen/black King blind swap. Slam from any hand. Red Kings and Jokers -1. +10 for a failed call.",
  "lobby.note.gringo": "Gringo: 10 peek, Jack spy, Queen blind swap, black King look and swap. Red Kings -3, Jokers 0. +10 for a failed call.",
  "lobby.note.cambio": "Cambio: 7-8 peek, 9-10 spy, Jack/Queen blind swap, black King look and swap. Stick from any hand. Red Kings -1, Jokers 0. A caller who ties loses.",
  "lobby.note.cabo": "Cabo: 7-8 peek, 9-10 spy, Jack/Queen blind swap. No slamming. Jokers 0, Jack 11, Queen 12, Kings 13. Lowest hand scores 0; +5 for a failed call, the caller wins ties.",
  "lobby.note.kaboo": "Kaboo: 7-8 peek, 9-10 spy, Jack/Queen blind swap, black King look and swap. Snap from any hand, 2 penalty cards. Jokers -1, red Kings 0, Jack 11, Queen 12, black King 13. Caller -5 if lowest, +5 if not.",
  "invite.text": "Join my Rafiki card game! Room code {code}",
  "invite.textCode": "Join my Rafiki card game! Open Rafiki, tap \"{join}\" and enter the room code {code}",
  "invite.linkCopied": "Invite link copied",
  "invite.codeCopied": "Room code {code} copied",
  "invite.inviteFriends": "Invite friends",
  "invite.playWithFriend": "Play with a friend",
  "invite.onWhatsApp": "Invite on WhatsApp",
  "invite.whatsappText": "Fancy a game of Rafiki? Join my table: {url}",

  // How slamming works (slides)
  "slamInfo.ownTitle": "SLAMMING FROM YOUR HAND",
  "slamInfo.discarded": "A card is discarded either by you or an opponent",
  "slamInfo.ownBelieve": "You believe you have an 8 in your hand.",
  "slamInfo.hitSlam": "You must hit the SLAM button immediately.",
  "slamInfo.ownSeconds": "You will have 10 seconds to select the correct card from your hand.",
  "slamInfo.ownClick": "You click on the card which you believe is the same rank as the one recently discarded.",
  "slamInfo.ownThisCard": "You believe this card in your hand is the 8.",
  "slamInfo.arrow": "Right arrow",
  "slamInfo.revealed": "The card is revealed; you are either correct or incorrect.",
  "slamInfo.correct": "CORRECT SLAM",
  "slamInfo.incorrect": "INCORRECT SLAM",
  "slamInfo.ownCorrect": "If you’re correct, the card is an 8 and you can remove it from your hand, leaving you with one less card in your hand.",
  "slamInfo.ownIncorrect": "If you’re incorrect, the card is revealed and you must put it back in your hand and take an extra card from the deck as a penalty.",
  "slamInfo.newHand": "Your new hand",
  "slamInfo.oppTitle": "SLAMMING FROM AN OPPONENT’S HAND",
  "slamInfo.oppBelieve": "You believe your opponent has an 8 in their hand.",
  "slamInfo.oppSeconds": "You will have 10 seconds to select the correct card from the table.",
  "slamInfo.oppSelect": "You select the card you believe matches the recently discarded card.",
  "slamInfo.oppHand": "Opponent's hand",
  "slamInfo.yourHand": "Your hand",
  "slamInfo.oppCorrect": "If you’re correct, you now select one of your own cards to give to your opponent. You have one less.",
  "slamInfo.oppIncorrect": "If you’re incorrect, the failed slam card is returned to the opponent’s hand. You must take another card from the deck to add to your hand as a penalty.",

  // After the game
  "common.dealing": "Dealing...",
  "share.beatComputers": "I just beat the computers at Rafiki 🃏 Think you can?",
  "share.wonGame": "I just won a game of Rafiki 🃏 Fancy a rematch?",
  "share.fancyGame": "Rafiki: peek, swap, slam and call RAFIKI! 🃏 Fancy a game?",
  "share.streakSuffix": " ({n}-day streak)",
  "share.text": "{brag}{extra} Free to play: {url}",
  "share.copied": "Copied! Paste it to a friend.",
  "share.shareWin": "Share your win",
  "share.streakNote": "{n}-day streak! Come back tomorrow to keep it going.",
  "board.scores": "Scores",
  "board.score": "Score",

  // Daily Rafiki and challenges
  "common.points": "{count} points",
  "daily.preview": "preview",
  "daily.beatComputers": "beat the computers",
  "daily.rankOf": "{ord} of {n}",
  "daily.todayRank": "Today: {ord} of {total}",
  "daily.youRank": "You {line}",
  "daily.titleN": "Daily Rafiki {label}",
  "daily.calledSuffix": " · called {call}",
  "daily.lowestWins": "(lowest wins)",
  "daily.beatMe": "Beat me: {url}",
  "over.penaltyBreakdown": "{base} + {n} penalty",
  "over.bonusBreakdown": "{base} − {n} bonus",
  "table.penaltyPill": "+{n} penalty",
  "daily.resultAria": "Daily Rafiki {label} result",
  "daily.nextIn": "Next daily in {time}",
  "challenge.shareText": "I scored {score} in Rafiki, beat me: {url}",
  "challenge.yourFriend": "Your friend",
  "challenge.yourScore": "Your score {mine}",
  "challenge.scores": "Your score {mine} — {who} scored {theirs}",
  "challenge.youWin": "{base}. You win!",
  "challenge.theyWin": "{base}. {who} wins this one.",
  "challenge.tie": "{base}. A tie!",
  "challenge.resultAria": "Challenge result",
  "challenge.title": "Challenge",
  "share.copyFailed": "Couldn't copy. Long-press the text to copy it.",
  "share.textAria": "Share text",
  "share.copy": "Copy",
  "share.copiedShort": "Copied!",
  "share.share": "Share",
  "share.whatsapp": "WhatsApp",
  "share.challengeCopiedShort": "Challenge link copied!",
  "share.linkCopyFailed": "Couldn't copy the link.",
  "chat.title": "Chat",
  "chat.offensive": "Offensive message?",
  "chat.report": "Report it",
  "chat.placeholder": "Write message...",

  "common.somethingWrong": "Something went wrong. Please try again.",
  "common.backToStart": "Back to the start page",
  "common.goToStart": "Go to the start page",
  "daily.pageTitle": "Daily Rafiki — one deal a day",
  "daily.metaDescription": "Daily Rafiki: the same cards for everyone, one go a day. Play the day's deal against two computer players and share your score.",
  "daily.headline": "Same cards for everyone today.",
  "daily.blurb": "One round against two computer players, dealt from today's date. Everyone who plays today gets this exact deal, so compare scores with your friends. One go.",
  "challenge.pageTitle": "Rafiki challenge — play the same deal",
  "start.rulesInYourLanguage": "Rules in English",
  "start.guidesInEnglish": "Guides (in English):",

  // Start screen
  "site.description": "Rafiki is a free online card game of memory, swaps and slams. Play with friends in a private room or against the computer. Like Cabo, Cambio and Golf.",
  "start.slow": "That's taking longer than usual. Check your connection and tap again.",
  "start.title": "Rafiki: free online card game with friends",
  "start.logoAlt": "Rafiki - A card game closely related to some other games such as Cambio, Cabo, Golf, Rat-a-Tat Cat, Pablo and Cactus.",
  "start.tagline": "Play with friends, win with masters",
  "start.playTogether": "Play together",
  "start.playComputer": "Play the computer",
  "start.joinGame": "Join game",
  "start.play": "Play",
  "start.quickPlay": "Quick Play",
  "start.learn": "Learn how to play",
  "start.howToPlay": "How to play",
  "start.playWithFriends": "Play with friends",
  "start.getDeck": "Get the deck",
  "start.logIn": "Log in",
  "start.signUp": "Sign up",
  "start.heading": "A free online card game to play with friends",
  "start.intro": "Rafiki is a fast memory card game for 2 to 6 players. Peek at your hidden cards, swap and spy, slam matching cards from any hand, and call \"Rafiki!\" when you think you hold the lowest hand. Play against computer players straight away, or invite friends to a private room. If you like Cabo, Cambio or Golf, you'll pick it up in one round.",

  // Home screen (create a room)
  "start.streakDone": "{n}-day streak. See you tomorrow!",
  "start.streakKeep": "{n}-day streak. Finish a game today to keep it going.",
  "start.joinRoom": "Join a room",
  "appBanner.text": "Rafiki is on Google Play",
  "appBanner.cta": "Get the app",
  "appBanner.close": "Close",
  "fb.howWasThat": "How was that?",
  "fb.good": "Loved it",
  "fb.ok": "It was OK",
  "fb.bad": "Not great",
  "fb.thanks": "Thanks!",
  "fb.tellMore": "Tell us more",
  "fb.placeholder": "What would make Rafiki better?",
  "fb.email": "Email (only if you'd like a reply)",
  "fb.send": "Send",
  "fb.sent": "Thanks, we read every message.",
  "fb.error": "That didn't send. Please try again.",
  "fb.menu": "Send feedback",
  "fb.menuSub": "Ideas, bugs, house rules: tell us anything.",
  "create.title": "Rafiki - Create Game",
  "create.welcome": "Welcome, {name}!",
  "create.adsRemoved": "Thanks! Ads are now removed.",
  "create.removeAdsPrice": "Remove ads ({price})",
  "create.removeAds": "Remove ads",
  "create.restored": "Purchase restored. Ads are now removed.",
  "create.noPurchase": "No previous purchase found for this store account.",
  "create.restore": "Restore purchases",
  "create.logoAlt": "Rafiki logo",
  "create.createPreset": "Create a {name} game",
  "create.daily": "Daily Rafiki",
  "create.createOwn": "Create own game",
  "create.logOut": "Log out",
  "create.deleteConfirm": "Delete your Rafiki account? This permanently removes your username, email, scores and leaderboard place. It cannot be undone.",
  "create.deleted": "Your account has been deleted.",
  "create.deleteFailed": "Sorry, we couldn't delete your account just now. Please email letsplayrafiki@gmail.com and we'll do it for you.",
  "create.deleteAccount": "Delete account",

  // Footer
  "footer.shop": "Deck & shop",
  "footer.contact": "Contact us",
  "footer.privacySettings": "Privacy and cookie settings",

  "game.title": "Rafiki - Room {code}",

  // Rules panel
  "rules.section.video": "Intro Video",
  "rules.section.aim": "Aim of the Game",
  "rules.section.setup": "Setting Up",
  "rules.section.actions": "Actions",
  "rules.section.slamming": "Slamming",
  "rules.section.calling": "Calling Rafiki!",
  "rules.section.scoring": "Scoring",
  "rules.section.winner": "Who's the Winner?",
  "rules.section.contact": "Contact us",
  "rules.open": "Open rules",
  "rules.minimise": "Minimise rules",
  "rules.logoAlt": "Rafiki Logo",
  "rules.tagline": "Play with friends, win with masters.",
  "rules.aim1": "To have the least number of points in your hand at the end of each round.",
  "rules.aim2": "Each player begins the game with a score of 0. At the end of each round, your points are totalled and added to your score.",
  "rules.aim3": "The player with the lowest score after the chosen number of rounds (1, 3 or 5) is the winner!",
  "rules.setup1": "Each player starts with 4 cards face down in front of them (their hand) with the rest of the cards face down in the deck.",
  "rules.setup2": "Each player then looks at, memorises and puts back the bottom two cards in their hand – without their opponent(s) seeing.",
  "rules.setup3": "Player one then draws a card from the deck. Each card denotes an action...",
  "rules.setup4": "You always draw from the deck: you can never take the top card of the discard pile.",
  "rules.blackKing": "Black King",
  "rules.redKing": "Red King",
  "rules.or": "{a} or {b}",
  "rules.playingPreset": "This room is playing {name} house rules.",
  "rules.keepOrThrow": "Any other card = “Keep or throw”.",
  "rules.keepOrThrowText": "Swap it with a card in your hand, or tap the discard pile to throw it straight away.",
  "rules.replaceText": "Replace one of the cards in your hand with the drawn card. The replaced card goes onto the discard pile.",
  "rules.isPeek": "{ranks} = “Look At Own Card”.",
  "rules.peekText": "Place onto the discard pile and then look at a card in your hand.",
  "rules.isSpy": "{ranks} = “Look At Opponent’s Card”.",
  "rules.spyText": "Place onto the discard pile and then look at a card in an opponent’s hand.",
  "rules.isBlindSwap": "{ranks} = “Blind Swap”.",
  "rules.blindSwapText": "Place onto the discard pile and then swap a card in your hand with an opponent’s, without looking.",
  "rules.isLookAndSwap": "{ranks} = “Look And Swap”.",
  "rules.lookAndSwapText": "Place onto the discard pile, look at an opponent’s card, then swap one of yours with any opponent’s card.",
  "rules.rafikiReplace": "Ace, 2, 3, 4, 5, 6, Joker, Red King = “Replace”.",
  "rules.rafikiPeek": "7 or 8 = “Look At Own Card”.",
  "rules.rafikiPeekText": "Place directly onto the discard pile and then look at a card in your hand.",
  "rules.rafikiSpy": "9 or 10 = “Look At Opponent’s Card”.",
  "rules.rafikiSpyText": "Place directly onto the discard pile and then look at a card in an opponent’s hand.",
  "rules.rafikiSwap": "Jack, Queen, Black King = “Blind Swap”.",
  "rules.rafikiSwapText": "Place directly onto the discard pile and then swap a card in your hand with a card in your opponent’s hand.",
  "rules.noSlamming": "This room is playing {name} house rules: there is no slamming.",
  "rules.noSlammingText": "Cards only leave your hand when you swap a drawn card in. Once a player has drawn their card from the deck and carried out the required actions, it is the turn of the next player.",
  "rules.anExtraCard": "an extra card",
  "rules.nExtraCards": "{n} extra cards",
  "rules.slamOwnOnly": "This room is playing {name} house rules: you can only slam cards from your own hand.",
  "rules.slamPenaltyN": "This room is playing {name} house rules: a wrong slam costs {n} penalty cards.",
  "rules.slam1": "As soon as a card is placed on the discard pile, if you believe there is a card in your hand or an opponent’s hand that matches that card in rank (i.e. the number / royalty), you can “Slam”.",
  "rules.slam2": "Press the Slam button and select the card you believe matches in rank. If the card matches, the Slam is correct.",
  "rules.slamFromYours": "Slamming from your hand:",
  "rules.slamOwnCorrect": "A correct Slam removes the Slam card from your hand. Fantastic! (-1 card in your hand)",
  "rules.slamOwnWrong": "An incorrect Slam means you must place the incorrect Slam card back into your hand and also take {penalty}from the deck for your hand as a penalty. Better luck next time! (+{n} card in your hand)",
  "rules.seeMore": "See more",
  "rules.slamFromTheirs": "Slamming from an opponent’s hand:",
  "rules.slamOppCorrect": "A correct Slam means you transfer one of the cards in your hand to the opponent’s hand. Fantastic! (-1 card in your hand)",
  "rules.slamOppWrong": "An incorrect Slam means you return the card you attempted to Slam back to the opponent’s hand, and then take {penalty} from the deck to put into your hand as a penalty. Better luck next time! (+{n} card in your hand)",
  "rules.slamOnce": "After one Slam, it is not possible to Slam again that turn. Once a player has drawn their card from the deck; carried out the required actions; and either no one attempts a Slam or a correct Slam has been played; it is the turn of the next player.",
  "rules.call1": "If a player thinks they have the least points in their hand, at the start of their next turn they call “{name}” (calling {name} is a turn in itself).",
  "rules.call2": "This can be done at any time during the game after each player has had three turns. If a player has no more cards in their hand, this is an automatic {name} at the beginning of their next turn.",
  "rules.call3": "Following a {name} call, each opponent has one more turn, but the hand of the {name} caller is protected (i.e. no cards can be added to, removed from, looked at or swapped with their hand).",
  "rules.call4": "Each player then reveals their hand and each player’s points are tallied…",
  "rules.pointsIntro": "Each card represents the following points:",
  "rules.pointsIntroPreset": "Each card represents the following points ({name} house rules):",
  "rules.jokersEq": "Jokers = {n}",
  "rules.jokersRedKingsEq": "Jokers and Red Kings = {n}",
  "rules.redKingsEq": "Red Kings = {n}",
  "rules.aceEq": "Ace = +1",
  "rules.faceValue": "2 – 10 = +face value",
  "rules.royalEq": "Royal cards (except Red Kings) = +10",
  "rules.jackEq": "Jack = {n}",
  "rules.queenEq": "Queen = {n}",
  "rules.kingEq": "{king} = {n}",
  "rules.lowestZero": "Lowest hand = 0 (everyone else scores their hand)",
  "rules.premature": "Premature {name}* = {n}",
  "rules.successful": "Successful {name} = {n}",
  "rules.prematureNote": "*If it transpires the {name} caller does not have the least points in their hand at the end of a round, they deserve a penalty!",
  "rules.callerWinsTies": "If the {name} caller’s score is the same as an opponent’s, the caller wins.",
  "rules.callerLosesTies": "This penalty applies if the {name} caller’s score is the same as an opponent’s.",
  "rules.noPenalty": "There is no points penalty for calling {name} too early, but if the caller’s score is the same as an opponent’s, the opponent wins.",
  "rules.cumulative": "Each player begins the game with a score of 0. At the end of each round the points are calculated and added to the cumulative score for each player.",
  "rules.example": "For example, a points total of 7 on an existing score of 0 gives a new score total of 7; a points total of -2 on an existing score of 50 gives a new score total of 48.",
  "rules.end1": "After the chosen number of rounds (1, 3 or 5), the player with the least points wins!",
  "rules.end2": "If it is a draw (players finish on the same score), the drawing players enter a winner-takes-all round of sudden death.",
  "rules.noVideo": "Your browser can't play this video. {link}.",
  "rules.downloadIt": "Download it",
  "rules.questions": "Questions, problems or ideas? Email us at",
  "rules.followUs": "Follow us on",
  "rules.newToRafiki": "New to Rafiki? Read the full {link}.",
  "rules.howToPlayGuide": "how to play guide",

  "common.logoAltSmall": "rakifi-logo",

  // Cookie banner (website)
  "cookies.aria": "Cookie choices",
  "cookies.text": "We use cookies for analytics and ads. See our {cookie} and {privacy}.",
  "cookies.cookiePolicy": "Cookie Policy",
  "cookies.privacyNotice": "Privacy Notice",
  "cookies.reject": "Reject",
  "cookies.accept": "Accept",
  // Global leaderboard (website)
  "leader.title": "Global LeaderBoard",
  "leader.rank": "Rank",
  "leader.name": "Name",
  "leader.plays": "Plays",
  "leader.wins": "Wins",
  "leader.search": "Enter your username to find your global rank",
  "leader.playsWins": "Plays: {plays} Wins: {wins}",

  // Tutorial (/learn)
  "tut.computersTurn": "Computer's turn",
  "tut.welcome": "Welcome to Rafiki",
  "tut.welcomeText": "Everyone has 4 cards face down. The aim is simple: {b}. You don't know most of your cards, so you peek, swap and remember. This game takes about two minutes.",
  "tut.welcomeBold": "finish with the lowest total",
  "tut.peekTitle": "Peek at your two nearest cards",
  "tut.peekText": "At the start you get one look at the two cards closest to you. Tap both glowing cards.",
  "tut.rememberTitle": "Remember them!",
  "tut.rememberText": "A {two} and a {nine}. They go back face down and you have to remember where they are. Card values:",
  "tut.drawTitle": "Your turn: draw a card",
  "tut.drawText": "Tap the deck. You can't take from the discard pile.",
  "tut.lowTitle": "A 3: that's a low card",
  "tut.lowText": "Low cards (Ace to 6, red Kings and Jokers) must go into your hand. Swap it with your {nine}: tap the 9's spot (bottom right). The 9 goes on the discard pile, and your total drops by 6.",
  "tut.againTitle": "Your turn again",
  "guide.tapDeckToDraw": "Tap the deck to draw.",
  "tut.sevenTitle": "A 7: a peek card",
  "tut.sevenText": "{b} let you look at one of your own cards. Power cards never go in your hand: they go straight on the discard pile and you use the power.",
  "tut.sevenBold": "7s and 8s",
  "tut.peekGlowing": "Tap the glowing card you haven't seen yet.",
  "tut.kingTitle": "A black King: 10 points",
  "tut.kingText": "That's a bad card to keep. Remember it's top left so you can get rid of it, then {b} to turn it back over.",
  "tut.kingBold": "tap it again",
  "tut.tapDeck": "Tap the deck.",
  "tut.queenTitle": "A Queen: a swap card",
  "tut.queenText": "{b} swap one of your cards with someone else's, without looking. It goes straight on the discard pile and the swap begins.",
  "tut.queenBold": "Jacks, Queens and black Kings",
  "tut.giveTitle": "Give away your King",
  "tut.giveText": "Tap your King (top left), then tap any of the computer's cards to swap them.",
  "tut.watchTitle": "Watch the pile",
  "tut.watchText": "The computer's turn. Keep an eye on what lands on the discard pile…",
  "tut.slamText": "A {two} just hit the pile, and you know your bottom-left card is a 2. Anyone can {slam} a matching card, even out of turn. Press {button}, then tap your 2.",
  "tut.slamWord": "slam",
  "tut.slamTap": "Tap your 2 (bottom left).",
  "tut.fewerTitle": "One card fewer!",
  "tut.fewerText": "A wrong slam earns you a penalty card, so only slam when you're sure. You can even slam someone else's card if you know it matches: then you give them one of yours.",
  "tut.callText": "You swapped out your 9, slammed your 2, and sent your King to the computer blind (whatever came back can't be worse than a King). From the third time round the table, you can press {b} at the start of your turn when you think you're lowest. Everyone else gets one more turn, and nobody can touch your cards.",
  "tut.winText": "Your cards add up to {mine} (Ace, 4 and 3), the computer's to {theirs}. Lowest total wins the round. That's Rafiki!",
  "tut.cpu9": "It drew a 9 and threw it on the pile to look at one of your cards.",
  "tut.cpu10": "It drew a 10 and used it to look at one of your cards. It's remembering too!",
  "tut.cpu8": "You called RAFIKI! The computer gets one last turn: it draws an 8 and uses it to peek.",
  "tut.cpu5": "It drew a low card and swapped it into its hand. Look what it threw away…",
  "tut.faceDown": "face-down card",
  "tut.pageTitle": "Learn how to play Rafiki",
  "tut.metaDescription": "Learn Rafiki in two minutes by playing a short practice game.",
  "tut.back": "Back to Rafiki",
  "tut.stepOf": "Step {n} of {total}",
  "tut.skip": "Skip",
  "tut.valRedKing": "Red King, Joker: −1",
  "tut.valAce": "Ace: 1",
  "tut.valFace": "2–10: face value",
  "tut.valCourt": "J, Q, black K: 10",
  "tut.next": "Next",
  "tut.playReal": "Play a real game",
  "tut.startAgain": "Start again",
  "tut.deckAlt": "deck",

  // Account pages (website)
  "account.cookiesDisabled": "Cookies are disabled",
  "account.usernameOrEmail": "Username or email address",
  "account.change": "Change?",
  "account.password": "Password",
  "account.forgotten": "Forgotten?",
  "account.newTo": "New to Rafiki?",
  "account.signUpNow": "Sign up now",
  "account.signupTitle": "Rafiki - Signup",
  "account.chooseUsername": "Choose a username",
  "account.emailFor": "Email address (for tournaments, competitions etc.)",
  "account.choosePassword": "Choose a password",
  "account.emailConsent": "By submitting your email address, you agree to receiving emails from Rafiki. We will not share your details with any other party.",
  "account.alreadySignedUp": "Already signed up?",
  "account.logInNow": "Log in now",
  "account.resetTitle": "Rafiki - Reset Password Link",
  "account.needReset": "Need to reset your password?",
  "account.resetHelp": "Enter your email address, and follow the link to set a new passwords",
  "account.sendReset": "Send password reset link",
  "account.remembered": "Remembered your password?",
  "account.signInNow": "Sign in now",
  "account.resetSent": "A password reset link has been sent.",
  "account.changePasswordTitle": "Rafiki - Change Password",
  "account.setNewPassword": "Set a new password",
  "account.noMatch": "Passwords don't match",
  "account.newPassword": "New password",
  "account.newPasswordAgain": "New password again",
  "account.savePassword": "Save new password",
  "account.changeUsernameTitle": "Rafiki - Change Username",
  "account.changeUsername": "Change your username",
  "account.newUsername": "New username",
  "account.realNameHint": "Don't use your real name. Your username is shown on leaderboards.",
  "account.usernameNotAllowed": "Please choose a different username.",
  "account.saveUsername": "Save new username",
  "account.usernameUpdated": "Your username has been updated.",
  "notFound.title": "Page not found",
  "notFound.body": "We couldn't find that page. It may have moved.",
  "notFound.home": "Go to the home page",
  "notFound.howTo": "How to play",
  "rotate.title": "Turn your phone upright to play",
  "rotate.body": "Rafiki fits best with your phone held upright.",
  "account.newsOptIn": "Send me occasional Rafiki news (you can unsubscribe at any time)",
  "account.emailUse": "We use your email for your account, for example to reset your password. We never share it with anyone else.",

  "remind.ask": "Get a nudge when tomorrow's Rafiki is ready?",
  "remind.morning": "Morning (9am)",
  "remind.lunch": "Lunchtime (12:30)",
  "remind.evening": "Evening (6:30pm)",
  "remind.notNow": "Not now",
  "remind.title": "Today's Rafiki is ready 🃏",
  "remind.body": "Same deal for everyone — can you beat your friends?",
  "remind.done": "Done! We'll nudge you when the next Daily Rafiki is ready. You can turn this off in the menu.",
  "remind.denied": "Notifications are off for Rafiki in your phone's settings. You can turn them on there.",
  "remind.menuOn": "Daily reminder: on",
  "remind.menuOff": "Daily reminder: off",
  "remind.channel": "Daily Rafiki reminder",
  // @end
};

// English forms used when {count} is 1 (other languages don't need them).
export const ONE: { [K in keyof typeof en]?: string } = {
  "common.points": "{count} point",

  // @one
};

export default en;
